import React from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { selectedBarIntervalSelector } from '@store/overviewDashboard/impactedViewers/selectors';
import { TOOLTIP_LABEL_FORMAT } from '@utils/constants';
import { TitleContainer, BarIntervalText } from './styled';

function Title() {
  const selectedBarInterval = useSelector(selectedBarIntervalSelector);

  return (
    <TitleContainer>
      {selectedBarInterval ? (
        <BarIntervalText>
          {moment(selectedBarInterval.from).format(TOOLTIP_LABEL_FORMAT)}
          &nbsp;to&nbsp;
          {moment(selectedBarInterval.to).format(TOOLTIP_LABEL_FORMAT)}
        </BarIntervalText>
      ) : null}
    </TitleContainer>
  );
}

export default Title;
